import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Bot, Check, X } from "lucide-react";

export default function JarvisDrafts() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/integrations/outbound-drafts").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const decide = async (d, decision) => {
    const note = decision === "reject" ? (window.prompt("Reason for rejecting (optional)") ?? "") : "";
    try { await api.post(`/integrations/outbound-drafts/${d.id}/decide`, { decision, note }); toast.success(decision === "approve" ? "Approved — Jarvis may now send it" : "Rejected"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  if (!rows.length) return null;
  return (
    <div className="border border-[#DFDAD0] bg-white p-4 mb-4 space-y-2" data-testid="jarvis-drafts">
      <div className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60 flex items-center gap-1"><Bot className="w-3.5 h-3.5" /> Jarvis drafts · {rows.length} · created via API, never sent without your approval</div>
      {rows.map((d) => (
        <div key={d.id} className="border-t border-[#DFDAD0] pt-2 text-sm" data-testid={`jarvis-draft-${d.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <button onClick={() => setOpen(open === d.id ? null : d.id)} className="text-left" data-testid={`jarvis-draft-toggle-${d.id}`}>
              <span className="font-mono text-[10px] uppercase mr-2 text-[#1C2530]/50">{d.channel}{d.mocked ? " · MOCKED" : ""}</span>
              <span className="font-medium">{d.company || d.lead_id}</span> · {d.subject || d.body.slice(0, 60)} → <span className="font-mono text-xs">{d.to || "no address"}</span>
              <span className="ml-2 font-mono text-[10px] text-[#1C2530]/50" data-testid={`jarvis-draft-from-${d.id}`}>from {d.owner_name}{d.from_address ? ` <${d.from_address}>` : ""}{!d.owner_mailbox_connected && d.channel === "email" ? " · OWNER MAILBOX NOT CONNECTED" : ""}</span>
              <span className={`ml-2 font-mono text-[10px] uppercase ${d.status === "approved" ? "text-[#3E8F99]" : "text-[#E2711D]"}`} data-testid={`jarvis-draft-status-${d.id}`}>{d.status.replace("_", " ")}</span>
            </button>
            {d.status === "pending_approval" && (
              <div className="flex gap-2">
                <button onClick={() => decide(d, "approve")} data-testid={`jarvis-draft-approve-${d.id}`} className="flex items-center gap-1 border border-[#3E8F99] text-[#3E8F99] px-2 py-1 text-xs font-mono uppercase hover:bg-[#3E8F99]/10"><Check className="w-3 h-3" /> Approve</button>
                <button onClick={() => decide(d, "reject")} data-testid={`jarvis-draft-reject-${d.id}`} className="flex items-center gap-1 border border-[#E50914] text-[#E50914] px-2 py-1 text-xs font-mono uppercase hover:bg-[#E50914]/10"><X className="w-3 h-3" /> Reject</button>
              </div>
            )}
          </div>
          {open === d.id && (
            <div className="mt-2 text-xs space-y-1" data-testid={`jarvis-draft-body-${d.id}`}>
              <div className="text-[#1C2530]/60 font-mono text-[10px]">Why: {d.reason}</div>
              <pre className="whitespace-pre-wrap font-sans bg-[#F5F3EE] p-3 border border-[#DFDAD0]">{d.body}</pre>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
